<template>
  <q-popup-edit ref="popup" v-model="popupVal" :buttons="buttonsComputed" @input="(v, iv) => saveInput(v)"
                @save="(v, iv) => save(v)">
    <slot v-bind:saveInput="saveInput" v-bind-popupVal="popupVal">
      <q-input :type="inputType" v-model="popupVal" dense autofocus @input="(v, iv) => saveInput(v)" @focus="onFocus"
               :min="min" :max="max" :rules="rules" ref="control" :class="smallControls?'inline-block':''" @keyup="onKeyup" />
      <q-btn v-if="smallControls" flat dense icon="done" size="sm" class="q-pr-none q-ml-sm" color="primary" @click="$refs.popup.set()"/>
    </slot>
  </q-popup-edit>
</template>

<script>
/**
 * Pretty simple wrapper around q-popup edit so that we can use it with vuex.
 * It is a very frustrating problem.
 * By default it only emits '@save' when the dialog is exited and there was a change made.
 * If you want to get updates on every keystroke (and another on cancel/save) then pass the 'input-updates' prop.
 */
export default {
  name: 'MPopupEdit',
  props: ['value', 'inputUpdates', 'inputType', 'max', 'min', 'rules', 'buttons', 'selectOnFocus', 'smallControls'],
  data () {
    return {
      popupVal: this.value
    }
  },
  watch: {
    value (newVal, oldVal) {
      this.popupVal = newVal
    }
  },
  computed: {
    buttonsComputed () {
      return (this.buttons !== undefined) ? this.buttons : true
    }
  },
  methods: {
    saveInput (val) {
      if (this.inputUpdates === undefined) return
      this.save(val)
    },
    save (val) {
      this.$emit('save', val)
    },
    // onShow () {
    //   this.popupVal = this.value
    // },
    show () {
      this.$refs.popup.$refs.menu.show()
    },
    onFocus () {
      if (this.selectOnFocus !== undefined) {
        this.$refs.control.select()
      }
    },
    onKeyup (e) {
      e.keyCode === 13 && this.$emit('enter', e)
    }
  }
}
</script>

<style scoped>

</style>
